export default __webpack_public_path__ + "static/media/Miter of the Sundered Skies.e2ae9365.jpg";